import request from '../../constants/fetch';
import queryString from 'query-string';
import pickBy from 'lodash/pickBy';

 /**
 * API Get Notifications
 * @returns {Promise<unknown>}
 */
export const getNotificationsService = (query, options = {}) => 
    request.get(`/notification?${queryString.stringify(pickBy(query, item => item !== ""), { arrayFormat: 'comma' })}`, options);

/**
 * API Check Notification
 * @returns {Promise<unknown>}
 */
export const checkNotificationService = (id, options = {}) => 
  request.put(`/notification/${id}?read=true`, options);

/**
 * API Check All Notifications
 * @returns {Promise<unknown>}
 */
export const checkAllNotificationsService = (id, options = {}) => 
 request.put(`/notification?read=true`, options);